import {
    Box,
    SvgIconProps,
    Typography
} from "@mui/material";
import React, {
    ElementType
} from "react";

type ItemLabelProps = {
    color: "error" | "success";
    text: string;
    Icon: ElementType<SvgIconProps>;
};

export const ItemLabel = (props: ItemLabelProps) => {
    const { color, text, Icon } = props;

    return (
        <Box
            display="flex"
            gap={0.5}
            alignItems="center"
            color={theme => theme.palette[color].main}
            bgcolor={theme => theme.palette[color].light}
            alignSelf="flex-start"
            px={0.5}
            py={0.25}
        >
            <Icon fontSize="small" color="inherit" />
            <Typography color="inherit" fontWeight={700} fontSize="0.75rem">
                {text}
            </Typography>
        </Box>
    );
};